import { IReward } from './IReward';
import { Reward } from './Reward';
import RewardDestinations from './RewardDestinations';
import RewardSources from './RewardSources';
import CalculationTypes from './CalculationTypes';
import PerTrxAmountCalcMethods from './PerTrxAmountCalcMethods';

export class FlexReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.FlexReward';

	public static readonly NAME: string = 'Flex Reward';

	destinationType: string = Object.keys(RewardDestinations)[0];

	rewardSource: string = Object.keys(RewardSources)[0];

	calculationType: string = Object.keys(CalculationTypes)[0];

	perTrxAmountCalcMethod: string = Object.keys(PerTrxAmountCalcMethods)[0];

	totalMaximumAmount: number = 0;

	rewardedTrxType: string = '';

	perTrxTypePercentage: number = 0;

	constructor(reward?: IReward) {
	  super(FlexReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.destinationType = (reward as any).destinationType;
	    this.rewardSource = (reward as any).rewardSource;
	    this.calculationType = (reward as any).calculationType;
	    this.totalMaximumAmount = (reward as any).totalMaximumAmount;
	    this.perTrxAmountCalcMethod = (reward as any).perTrxAmountCalcMethod;
	    this.rewardedTrxType = (reward as any).rewardedTrxType;
	    this.perTrxTypePercentage = (reward as any).perTrxTypePercentage;
	  }
	}

	/* eslint-disable class-methods-use-this */
	getDescription(): string {
	  return 'Flex Reward';
	}
	/* eslint-enable class-methods-use-this */

	clone(): IReward {
	  const clone = new FlexReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default FlexReward;
